/* eslint-disable */
import Echo from 'laravel-echo';
import Vue from 'vue';

window.Pusher = require('pusher-js');

const echoConfig = {
  cluster: 'mt-1',
  broadcaster: 'pusher',
  key: '66e2e3a9b9a761d522a1',
  wsHost: process.env.SOCKET_HOST,
  wsPort: 6001,
  wssPort: 443,
  forceTLS: process.env.SOCKET_TLS,
  enabledTransports: ['ws', 'wss'],
  encrypted: false,
  disableStats: true,
  authorizer: (channel) => {
    return {
      // eslint-disable-next-line
      authorize: (socketId, callback) => {
        Vue.$http
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            // eslint-disable-next-line node/no-callback-literal
            callback(false, response.data);
          })
          .catch((error) => {
            // eslint-disable-next-line node/no-callback-literal
            callback(true, error);
          });
      },
    };
  },
};


Vue.prototype.$echo = new Echo(echoConfig);



// WEBPACK FOOTER //
// ./src/plugins/echo.js